<template>
  <v-breadcrumbs v-if="showBreadcrumbs" class="pa-0 category-breadcrumbs" :items="items">
    <template v-slot:divider>
      <span>/</span>
    </template>
  </v-breadcrumbs>
</template>

<script>
  import Mobile from '../../inc/mixins/mobile';

  export default {
    props: {
      items: {
        required: true,
        type: Array
      }
    },
    mixins: [Mobile],
    computed: {
      showBreadcrumbs() {
        return (this.items || []).length > 1;
      }
    }
  }
</script>
<style>
  .category-breadcrumbs .v-breadcrumbs__divider {
    padding: 0px 8px !important;
  }
</style>